import { createContext, useContext, useState, useEffect } from 'react';

const EditModeContext = createContext({
  isEditMode: false,
  setIsEditMode: () => {},
  sendEditMessage: () => {},
});

export const useEditMode = () => useContext(EditModeContext);

export const EditModeProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  // Check if we're inside an iframe (being edited from admin)
  useEffect(() => {
    const checkEditMode = () => {
      // Check if we're in an iframe
      const isInIframe = window.self !== window.top;
      
      // Listen for messages from parent to enable edit mode
      const handleMessage = (event) => {
        if (event.data?.type === 'ENABLE_EDIT_MODE') {
          setIsEditMode(true);
        } else if (event.data?.type === 'DISABLE_EDIT_MODE') {
          setIsEditMode(false);
        }
      };

      if (isInIframe) {
        window.addEventListener('message', handleMessage);
        // Request edit mode status from parent
        window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
      }

      return () => {
        window.removeEventListener('message', handleMessage);
      };
    };

    checkEditMode();
  }, []);

  // Send a message to the parent editor when an element is clicked
  const sendEditMessage = (elementType, elementId, elementData = {}) => {
    if (window.self !== window.top) {
      window.parent.postMessage({
        type: 'ELEMENT_CLICKED',
        elementType,
        elementId,
        elementData,
      }, '*');
    }
  };

  return (
    <EditModeContext.Provider value={{ isEditMode, setIsEditMode, sendEditMessage }}>
      {children}
    </EditModeContext.Provider>
  );
};

export default EditModeContext;
